"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = void 0;
var react_1 = __importDefault(require("react"));
var Label_scss_1 = __importDefault(require("./Label.scss"));
var LabelContext_1 = require("./LabelContext");
var Error_1 = require("./Error");
var Label = function (props) {
    var res = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("label", { id: "".concat(props.id, "-label"), className: "".concat(Label_scss_1.default['au-label'], " \n        ").concat(props.required ? Label_scss_1.default['au-label-required'] : ''), htmlFor: props.id },
            props.label,
            props.required && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("span", { className: Label_scss_1.default['au-label-required-icon'], "aria-hidden": "true" }),
                react_1.default.createElement("span", { className: "sr-only" }, "Required")))),
        react_1.default.createElement(LabelContext_1.LabelContext.Provider, { value: {
                id: props.id,
                state: props.error ? 'invalid' : undefined,
                describedBy: props.hint || props.error ? "".concat(props.id, "-hint") : undefined,
            } },
            props.hint && !props.error && (react_1.default.createElement("span", { className: Label_scss_1.default['au-hint-text'], id: "".concat(props.id, "-hint") }, props.hint)),
            props.error && (react_1.default.createElement("span", { className: Label_scss_1.default['au-error-text'], id: "".concat(props.id, "-hint") },
                react_1.default.createElement(Error_1.Error, { error: props.error }))),
            props.children)));
    return props.className ? react_1.default.createElement("div", { className: props.className }, res) : res;
};
exports.Label = Label;
//# sourceMappingURL=Label.js.map